<template>
  <div class="tss-footer">
    <div class="fotter-box">
      <div class="menuList">
        <div class="item">TSS RENOVATION SERVICE LTD.PART</div>
        <div class="item" @click="selectMenu(1)">หน้าแรก</div>
        <div class="item" @click="selectMenu(2)"> สินค้าและบริการ</div>
        <div class="item" @click="selectMenu(3)">เกี่ยวกับเรา</div>
        <div class="item" @click="selectMenu(4)">ความแข็งแกร่งของทีม</div>
        <div class="item" @click="selectMenu(5)">ติดต่อเรา</div>
      </div>
      <div class="itemList">
        <div class="item">ติดต่อเรา</div>
        <div class="item">
          <img src="../assets/tel.png" alt="">
          <div class="lable">949502179</div>
        </div>
        <div class="item">
          <img src="../assets/email.png" alt="">
          <div class="lable">css@tssrenovation.com</div>
        </div>
      </div>
      <div class="itemList">
        <div class="item">ที่อยู่</div>
        <div class="item">
          <img src="../assets/address.png" alt="">
          <div class="lable">39/43 หมู่ที่ 7 ตำบลบ้านสร้าง อำเภอบางปะอิน จ.พระนครศรีอยุธยา 13170</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fotter",
  data() {
    return {
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        case 5:
          this.$router.push({ path: "contact" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tss-footer {
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  background: #303937;

  .fotter-box {
    display: flex;
    justify-content: space-between;
    padding: 64px 360px;

    .menuList {
      width: 33.3%;

      .item {
        margin-bottom: 12px;
        font-size: 14px;
        color: #999999;
        line-height: 28px;
        cursor: pointer;
      }

      .item:nth-child(1) {
        margin-bottom: 24px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
      }
    }

    .itemList {
      width: 33.3%;

      .item {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        img {
          margin-right: 16px;
          width: 24px;
          height: 24px;
        }

        .lable {
          font-size: 16px;
          color: #999999;
          line-height: 19px;
        }
      }

      .item:nth-child(1) {
        margin-bottom: 24px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
      }
    }
  }
}
</style>
